
import React from 'react';
import { Card } from "@/components/ui/card";
import CompareSection from '@/components/compare/CompareSection';

export const CompareCard: React.FC = () => {
  return (
    <CompareSection />
  );
};

export default CompareCard;
